import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
`;

const StyledNumberWrapper = styled.div`
	height: 60px;
	margin-top: 30px;
`;

const StyledContactName = styled(Text)`
	font-weight: 500;
	font-size: 14px;
	text-align: center;
	color: #ffffff;
	transition: opacity 0.3s ease;
	height: 16px;
`;

const StyledNumber = styled(Text)`
	font-weight: 500;
	font-size: 30px;
	text-align: center;
	color: #ffffff;
	margin-top: 10px;
	height: 34px;
	transition: margin-top 0.3s ease;
`;

const StyledGrid = styled.div`
	display: grid;
	grid-template-columns: repeat(3, 60px);
	gap: 20px;
	margin-top: 26px;
`;

const StyledButton = styled.div<{ $disabled?: boolean }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 60px;
	height: 60px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 60px;
	transition: background-color 0.3s ease;

	${({ $disabled }) =>
		$disabled
			? css`
					img,
					${Text} {
						opacity: 0.25;
					}
			  `
			: css`
					cursor: pointer;

					&:hover {
						background-color: rgba(255, 255, 255, 0.25);
					}
			  `}

	${Text} {
		font-weight: 500;
		font-size: 24px;
		color: #ffffff;
		transition: opacity 0.3s ease;
	}

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		transition: opacity 0.3s ease;
	}
`;

const StyledCallButton = styled(StyledButton)`
	background-color: #2fa849;

	&:hover {
		background-color: #2fa849;
	}
`;

export {
	StyledButton,
	StyledCallButton,
	StyledContactName,
	StyledContainer,
	StyledGrid,
	StyledNumber,
	StyledNumberWrapper,
};
